//import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";
class AttendStateFunc
{
  static attend_color_json:any={
    none:{"background":"#707070"},
    attend:{"background":"#E0BA7B"},
    late:{"background":"#ea880b"},
    absent:{"background":"#E18685"},
    out:{"background":"#B0BA3F"},
  };
  static select_arr={
    a_sort_detail:[
      {"value":"attend","text":"등원"},
      {"value":"late","text":"지각"},
      {"value":"absent","text":"결석"},
      {"value":"out","text":"하원"},
    ],
  };
  static get_color_by_attend_info(inData:any){
    let opt_obj={
      attend_info:null,
      ...inData
    };
    let this_obj=this;
    let attend_info=opt_obj.attend_info;
    let state_data={"value":"","text":"미등원","background":this_obj.attend_color_json.none.background};
    let attend_in_state_arr=[
      {"value":"attend","text":"등원","background":this_obj.attend_color_json.attend.background},
      {"value":"late","text":"지각","background":this_obj.attend_color_json.late.background},
      {"value":"absent","text":"결석","background":this_obj.attend_color_json.absent.background},
    ];
    if(attend_info["a_sort"]=="in"){
      for(let i=0;i<attend_in_state_arr.length;i++){
        let item=attend_in_state_arr[i];
        if(item["value"]==attend_info["a_sort_detail"]){
          state_data={...item};
        }
      }
    }else{
      state_data={"value":"","text":"하원","background":this_obj.attend_color_json.out.background};
    }
    return state_data;
  };
  static get_attend_data_by_user_info(inData:any){
    let opt_obj={
      user_info:null,
      select_date:"",
      ...inData
    };
    let this_obj=this;
    let user_info=opt_obj.user_info;
    let select_date=opt_obj.select_date;
    let attend_data:any={
      in:null,
      out:null,
      back_color:"#707070",
      text:"",
      time:"",
      show_text:"미등원",
    };
    let attend_in_info:any=null;
    if(user_info.attend_in_arr&&user_info.attend_in_arr.length>0){
      for(let i=0;i<user_info.attend_in_arr.length;i++){
        let row_attend_info=user_info.attend_in_arr[i];
        if(attend_in_info==null){
          if(select_date!=""){
            if(select_date==row_attend_info["a_ymd"]){
              attend_in_info=row_attend_info;
            }
          }else{
            attend_in_info=row_attend_info;
          }
        }
      }
    }
    let attend_out_info:any=null;
    if(user_info.attend_out_arr&&user_info.attend_out_arr.length>0){
      for(let i=0;i<user_info.attend_out_arr.length;i++){
        let row_attend_info=user_info.attend_out_arr[i];
        if(attend_out_info==null){
          if(select_date!=""){
            if(select_date==row_attend_info["a_ymd"]){
              attend_out_info=row_attend_info;
            }
          }else{
            attend_out_info=row_attend_info;
          }
        }
      }
      attend_out_info=user_info.attend_out_arr[0];
    }
    attend_data.in=attend_in_info;
    if(attend_in_info!=null){
      attend_data.out=attend_out_info;
    }

    if (attend_in_info != null) {
      let tmp_color_data=this_obj.get_color_by_attend_info({
        attend_info: attend_in_info,
      });
      attend_data.back_color = tmp_color_data.background;
      attend_data.text = tmp_color_data.text;
      attend_data.time=attend_in_info.a_time;
      attend_data.show_text=attend_data.text;
      if(attend_data.text!="결석"){
        attend_data.show_text=attend_data.time.substring(0,5);
      }
    }
    if (attend_out_info != null) {
      let tmp_color_data=this_obj.get_color_by_attend_info({
        attend_info: attend_out_info,
      });
      attend_data.back_color = tmp_color_data.background;
      attend_data.text = tmp_color_data.text;
      attend_data.time=attend_out_info.a_time;
      attend_data.show_text=attend_data.text;
    }

    return attend_data;
  };
  static get_user_arr_by_attend_order(inData:any){
    let opt_obj={
      user_arr:[],
      select_date:"",
      ...inData
    };
    let this_obj=this;
    let user_arr=opt_obj.user_arr;
    let select_date=opt_obj.select_date;
    let change_user_arr:any=[];
    let attend_user_arr:any=[];
    let absent_user_arr:any=[];
    let etc_user_arr:any=[];
    for(let u_i=0;u_i<user_arr.length;u_i++){
      let row_info=user_arr[u_i];
      if(row_info.attend_in_arr&&row_info.attend_in_arr.length>0){
        let attend_data=this_obj.get_attend_data_by_user_info({
          user_info: row_info,
          select_date: select_date,
        });
        if(attend_data.in){
          if(attend_data.in.a_sort_detail=="absent"){
            absent_user_arr.push(row_info);
          }else{
            attend_user_arr.push(row_info);
          }
        }else{
          etc_user_arr.push(row_info);
        }
      }else{
        etc_user_arr.push(row_info);
      }
    }
    change_user_arr=[
      ...attend_user_arr,
      ...etc_user_arr,
      ...absent_user_arr,
    ];
    return change_user_arr;
  };
}
export default AttendStateFunc;